import calender from "assets/images/Wallet.svg";
import time from "assets/images/time.svg";
import { ViewDetail, ReceipeDetail } from "./style";
import receipe from "assets/images/receipe.svg";
import Button from "components/particles/primary-button";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSesssionDetails } from "./useHook";
import { useSelector } from "react-redux";

export default function ChifSessionDetail() {
  const { getSessionByUserById, generatePdfForUserSession } =
    useSesssionDetails();
  const [pdfData, setPdfData] = useState<any>({});
  const [dishDetails, setDishDetails] = useState<any>({});

  const location = useLocation();
  const { sessionId } = location.state || {};

  useEffect(() => {
    console.log("Session ID from location.state:", sessionId);
    if (sessionId) {
      getSessionByUserById(sessionId, setDishDetails);
    }
  }, [sessionId]);

  const handlePrint = async (sessionId: any) => {
    console.log("Generating PDF for session ID:", sessionId);
    const response = await generatePdfForUserSession(sessionId, setPdfData);
    console.log("PDF generation response:", response);
    if (response?.status) {
      window.open(response.pdfPath, "_blank");
    } else {
      console.error("Failed to generate PDF");
    }
  };

  const [timeZone, setTimeZone] = useState("");
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const os = new Date().getTimezoneOffset();
    console.log("Detected Time Zone:", tz);
    console.log("Detected Offset (minutes from UTC):", os);
    setTimeZone(tz);
    setOffset(os);
  }, []);

  return (
    <ViewDetail>
      {/* <p>Time Zone: {timeZone}</p>
      <p>Offset from UTC (in minutes): {offset}</p> */}
      <div className="title no-print">
        <h1>Preparation Detail</h1>
        <Button
          title="Download Pdf"
          width="16rem"
          fill="true"
          backgroundcolor="#007AFF"
          onclick={() => handlePrint(sessionId)}
        />
      </div>
      {dishDetails && Array.isArray(dishDetails) ? (
        dishDetails.map((item: any, dishIndex: number) => (
          <div className="print-container print-only content" key={dishIndex}>

            <div className="view-detail-top-section">
              <div>
                <h2>{item?.homeCook?.homeCookName} </h2>
              </div>
              <div className="date-time-container">
                {/* <div className="date-time">
                  <img src={calender} alt="img" />
                  <h1>
                    {new Date(item.sessionDetails?.sessionDate).toLocaleDateString()}
                  </h1>
                </div> */}
                <div className="date-time">
                  <img src={calender} alt="img" />
                  <h1>
                    {item.sessionDetails?.sessionDate && (() => {
                      console.log(
                        `Original sessionDate from API (string):`,
                        item.sessionDetails.sessionDate
                      );

                      // Base date from API date string (assuming API sends YYYY-MM-DD format)
                      const baseDate = new Date(item.sessionDetails.sessionDate);
                      console.log("Base Date (interpreted in local TZ):", baseDate);

                      // Adjust date according to detected offset
                      const adjustedDate = new Date(baseDate.getTime() + (offset * 60 * 1000));
                      console.log("Adjusted Date after applying offset:", adjustedDate);

                      return adjustedDate.toLocaleDateString([], {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      });
                    })()}
                  </h1>
                </div>

                <div className="date-time">
                  <img src={time} alt="img" />
                  <h1>
                    {/* {item.sessionDetails?.sessionTime &&
                      new Date(
                        `1970-01-01T${item.sessionDetails.sessionTime}`
                      ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })} */}
                    {item.sessionDetails?.sessionTime && (() => {
                      console.log(
                        `Original sessionTime from API (string):`,
                        item.sessionDetails.sessionTime
                      );

                      // Base date from API time string
                      const baseDate = new Date(`1970-01-01T${item.sessionDetails.sessionTime}`);
                      console.log("Base Date (interpreted in local TZ):", baseDate);

                      // Adjust time according to detected offset
                      const adjustedDate = new Date(baseDate.getTime() + (offset * 60 * 1000));
                      console.log("Adjusted Date after applying offset:", adjustedDate);

                      return adjustedDate.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      });
                    })()}
                  </h1>
                </div>
              </div>
            </div>
            <ReceipeDetail>
              <div>
                <h2>{item?.dish.dishName}</h2>
                <p>
                  {item?.dish.serving} Servings | Prep Time{" "}
                  {item?.dish.preparationTime} mins | Total Time: 1 Hour
                </p>
                <h1>Ingredients</h1>
                <ul style={{ listStyleType: "none" }}>
                  {item?.dish?.ingredients?.map((ing: any, index: number) => (
                    <li key={index}>{ing.ingredientName}</li>
                  ))}
                </ul>
                <h1>Pre-Cooking Steps</h1>
                <ul>
                  {item?.dish?.preCookingSteps
                    ?.split("\n")
                    .filter((step: any) => step.trim() !== "")
                    .map((step: string, index: number) => (
                      <li key={index}>
                        {step.replace(/^(\s*[\d•\-•]*\s*)/, "").trim()}
                      </li>
                    ))}
                </ul>

                <h1>Pre-Session Setup</h1>
                <ul>
                  {item?.dish?.preCookingSetUp
                    ?.split("\n")
                    .filter((step: any) => step.trim() !== "")
                    .map((step: string, index: number) => (
                      <li key={index}>
                        {step.replace(/^(\s*[\d•\-•]*\s*)/, "").trim()}
                      </li>
                    ))}
                </ul>
              </div>
              <div className="receipe-img">
                <img src={item?.dish?.coverImage[0]} alt="img" />
                <div className="receipe-img-detail">
                  {item?.dish?.dietaries?.map((dietary: any, index: number) => (
                    <div className="receipe-imag-detail-cart" key={index}>
                      <span
                        style={{
                          width: "27px",
                          height: "27px",
                          display: "flex",
                          borderRadius: "1rem",
                          border: "1px solid #808D9E",
                        }}
                      ></span>
                      <span>{dietary.dietaryName}</span>
                    </div>
                  ))}
                </div>
              </div>
            </ReceipeDetail>
          </div>
        ))
      ) : (
        <h1>Loading...</h1>
      )}
    </ViewDetail>
  );
}
